<template>
<div id="trafico-detalle-facturas">

    <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal">
                    <i class="fa fa-file-archive-o" aria-hidden="true"></i>&nbsp;
                    <span class="subheading">
                        <strong>Cargar Archivo ZIP/XML</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>
                <br /><br />
                <v-btn icon @click.native="modal = false; reset()" class="close_modal">
                    <v-icon class="white--text">cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <input type="file" accept="application/xml, application/zip" id="file" ref="file" v-on:change="handleFileUpload()" />
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false; reset()">
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" :loading="loading" :disabled="!showfile" @click.native="submitFile()">
                    <v-icon>done</v-icon>Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modalFactura" max-width="40%" style=" z-index: 400 !important;">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal">
                    <i class="fa fa-file-o" aria-hidden="true"></i>&nbsp;
                    <span class="subheading">
                        <strong>Adjuntar Documento a Factura: {{modalFacturaNumero}}</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modalFactura = false; modalFacturaNumero=''; reset()" class="close_modal">
                    <v-icon class="white--text">cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-chip outlined v-if="verificaArchivo(modalFacturaArchivo)" color="info" text-color="indigo">
                    <v-avatar>
                        <v-icon color="indigo">info</v-icon>
                    </v-avatar>
                    <strong>{{verificaArchivo(modalFacturaArchivo) ? "Ya se adjuntó un documento a esta factura. Si adjunta otro, se reemplazará el existente." : ''}}</strong>
                </v-chip>

                <br v-if="verificaArchivo(modalFacturaArchivo)" />
                <br v-if="verificaArchivo(modalFacturaArchivo)" />

                <v-container>
                    <input type="file" accept="application/pdf" id="fileFactura" ref="fileFactura" v-on:change="handleFileUploadFactura()" />
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click.native="modalFactura = false; modalFacturaNumero=''; reset()">
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn small color="error" :loading="loadingDelete" v-show="verificaArchivo(modalFacturaArchivo)" @click.native="deleteFileFactura(modalFacturaArchivo)">
                    <v-icon>delete_forever</v-icon>Eliminar
                </v-btn>
                <v-btn small color="info" :loading="loadingDownload" v-show="verificaArchivo(modalFacturaArchivo)" @click.native="downloadFileFactura(modalFacturaArchivo)">
                    <v-icon>arrow_downward</v-icon>Descargar
                </v-btn>
                <v-btn small color="success" :loading="loading" :disabled="!showfile" @click.native="submitFileFactura(modalFacturaRfc)">
                    <v-icon>arrow_upward</v-icon>Adjuntar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modalUpload" max-width="40%" style=" z-index: 400 !important;">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">arrow_upward</v-icon>&nbsp;
                    <span class="subheading">
                        <strong>Cargar Plantilla Excel</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>
                <br /><br />
                <v-btn icon @click.native="modalUpload = false" class="close_modal">
                    <v-icon class="white--text">cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="Layout Facturas.xlsx">
                        <v-btn fab small dark class="close_modal" color="purple darken-2" title="Descargar Plantilla" v-tippy>
                            <v-icon dark>receipt</v-icon>
                        </v-btn>
                    </exportar-excel>
                    <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" :smallIcon=true title="Cargar Plantilla" icon="cloud_upload" :showIcon=false />

                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalUpload = false">
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-btn ref="scrollBtn" v-show="false" @click="$vuetify.goTo((ultimoDetalle),{duration: 1500,offset: 100})"> Scroll
    </v-btn>
    <v-form ref="form" id="detalle_facturas_form">

        <div class="row">
            <div class="col-xs-1">
                <v-btn fab dark x-small color="green" v-on:click="addNew(); $vuetify.goTo('#sumarizeDiv',{duration: 1500,offset: 100})" title="Agregar" v-tippy>
                    <v-icon dark>add</v-icon>
                </v-btn>
            </div>
            <div class="col-xs-1">
                <v-btn fab x-small dark color="orange darken-1" title="Cargar ZIP/XML" v-tippy @click="modal=true">
                    <v-icon dark>folder_open</v-icon>
                </v-btn>
            </div>
            <div class="col-xs-1">
                <v-btn fab x-small dark color="blue darken-1" title="Cargar Plantilla" v-tippy @click="modalUpload=true">
                    <v-icon dark>cloud_upload</v-icon>
                </v-btn>
            </div>

            <div class="col-xs-8">

            </div>
        </div>
        <div class="row">

            <div class="col-xs-10"></div>
        </div>
        <div v-for="(detalle, index) in detalles" v-bind:key="index" @keyup.enter="nextTab">
            <v-row style="flex-wrap: nowrap;">
                <v-col cols="2" class="flex-grow-0 flex-shrink-0">
                    <v-autocomplete v-model="detalle.emisor" :items="emisores" :hide-no-data="true" item-text="metadato" item-value="metadato" label="Selecciona un Emisor/Destinatario" :rules="[rules.required]" @input="setEmisor(detalle.emisor, index)"></v-autocomplete>

                </v-col>
                <v-col cols="1" class="flex-grow-1 flex-shrink-0">
                    <v-text-field label="Tax ID" type="text" autocomplete="off" v-model="detalle.tax_id" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                    <v-text-field :name="'nombre['+index+']'" label="País Vendedor" type="text" autocomplete="off" v-model="detalle.pais_vendedor" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                    <v-text-field label="Incoterm" type="text" autocomplete="off" v-model="detalle.incoterm"></v-text-field>
                </v-col>
                <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                    <v-text-field label="Número Factura" type="text" autocomplete="off" v-model="detalle.numero" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                    <v-text-field label="Número Exportador" type="text" autocomplete="off" v-model="detalle.numero_exportador"></v-text-field>
                </v-col>
                <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                    <v-menu offset-x :ref="'mf'+detalle.index" :close-on-content-click="false" v-model="detalle.menu" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                         <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" label="Fecha Expedición" type="text" prepend-icon="event"  mask="####-##-##" :value="parseDatePicker(detalle.fecha)" :rules="[rules.required]"></v-text-field>                           
                         </template>
                        <v-date-picker v-model="detalle.fecha" no-title @input="detalle.menu = false; detalle.fecha = parseDate(detalle.fecha); " locale="es-mx"></v-date-picker>
                     </v-menu>                    

                </v-col>
                <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                    <v-text-field label="Total USD" type="text" autocomplete="off" :readonly="detalle.mercancias!=undefined && detalle.mercancias.length>0" v-model="detalle.importe" :rules="[rules.number, rules.required]"></v-text-field>

                </v-col>
                <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                    <v-speed-dial :id="index" direction="left" open-on-hover>
                        <template v-slot:activator>
                            <v-btn :id="index" x-small fab dark color="primary">
                                <v-icon>reorder</v-icon>
                            </v-btn>
                        </template>
                        <v-btn fab dark x-small color="blue-grey darken-1" v-if="(detalle.archivo=='' || verificaArchivo(detalle.archivo))" @click="addFileFactura(detalle.numero, detalle.tax_id, detalle.archivo)" title="Agregar Documento" v-tippy>
                            <v-icon dark>attach_file</v-icon>
                        </v-btn>
                        <v-btn fab dark x-small color="blue-grey darken-3" @click="addDetail(index)" title="Agregar Mercancía" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                        <v-btn fab dark x-small color="red" @click="remove(index)" title="Eliminar Factura" v-tippy>
                            <v-icon dark>remove</v-icon>
                        </v-btn>
                    </v-speed-dial>
                </v-col>
            </v-row>

            <!-- DETALLE -->
            <div id="detalle_mercancias">
                <div v-for="(detalleMercancia, indexMercancia) in detalle['mercancias']" v-bind:key="indexMercancia">
                    <hr id="separaMercancia" v-show="indexMercancia != 0">
                    <v-row v-bind:id="'newMercancia'+index+'_'+indexMercancia">
                        <v-col cols="1" class="flex-grow-0 flex-shrink-0">
                            <v-text-field label="# Partida" type="text" autocomplete="off" v-model="detalleMercancia.numero_partida" :rules="[rules.entero, rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Fracc Aranc" type="text" autocomplete="off" v-model="detalleMercancia.fraccion_arancelaria" maxlength="25"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-0">
                            <v-text-field label="# Bultos" type="text" autocomplete="off" v-model="detalleMercancia.numero_bultos" :rules="[validaCantidadEnteraOpcional]"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="UM Bultos" type="text" autocomplete="off" v-model="detalleMercancia.unidad_bultos" maxlength="10"></v-text-field>
                        </v-col>
                        <v-col cols="2" class="flex-grow-0 flex-shrink-0">
                            <v-text-field label="Descripción Genérica" type="text" autocomplete="off" v-model="detalleMercancia.descripcion" maxlength="256" :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Clave Unidad Medida" type="text" autocomplete="off" v-model="detalleMercancia.clave_um" maxlength="10" :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Tipo de Moneda" type="text" autocomplete="off" v-model="detalleMercancia.moneda" maxlength="3" :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Cantidad" type="text" autocomplete="off" v-model="detalleMercancia.cantidad" :rules="[rules.number, rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Valor Unitario" type="text" autocomplete="off" v-model="detalleMercancia.valor_unitario" :rules="[rules.number, rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Valor Total" type="text" autocomplete="off" v-model="detalleMercancia.valor_total" :rules="[rules.number, rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Valor en Dólares" type="text" autocomplete="off" v-model="detalleMercancia.valor_dolares" :rules="[rules.number, rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Marca" type="text" autocomplete="off" v-model="detalleMercancia.marca" maxlength="100"></v-text-field>
                        </v-col>
                        <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Modelo" type="text" autocomplete="off" v-model="detalleMercancia.modelo" maxlength="50"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Sub-modelo" type="text" autocomplete="off" v-model="detalleMercancia.submodelo" maxlength="50"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="# Serie" type="text" autocomplete="off" v-model="detalleMercancia.numero_serie" maxlength="25"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="CBM" type="text" autocomplete="off" v-model="detalleMercancia.cbm" :rules="[rules.number]"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Peso Neto" type="text" autocomplete="off" v-model="detalleMercancia.peso_neto" :rules="[rules.number]"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Peso Bruto" type="text" autocomplete="off" v-model="detalleMercancia.peso_bruto" :rules="[rules.number]"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-btn fab dark x-small color="red" @click="removeDetail(index, indexMercancia)" title="Eliminar Mercancía" v-tippy>
                                <v-icon dark>remove</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>

                </div>
            </div> <!-- Detalle Mercancias-->

            <hr id="separaFactura">

        </div>
        <p id="sumarizeDiv" class="text-right"><span v-if="total_usd>0" style="font-size:14pt">TOTAL USD: {{total_usd | moneda}}</span></p>
    </v-form>

    <p />
    <p />
    <p />
</div>
</template>

<script>
import axios from 'axios';
import Vue from "vue";
import moment, {
    invalid
} from "moment";

export default {
    components: {},

    data: () => ({
        fab: false,
        detalles: [],
        total_usd: 0, //Sumatoria del importe de las facturas     
        emisores: [],
        formUpdated: false,
        file: '',
        fileName: '',
        fileFactura: '',
        sizeFactura: 0,
        fileFacturaName: '',
        filetext: '',
        showfile: false,
        URL: '',
        modal: false,
        modalFactura: false,
        modalFacturaArchivo: '',
        modalFacturaNumero: '',
        modalFacturaRfc: '',
        modalUpload: false,
        show_loading: false,
        loading: false,
        loadingDelete: false,
        loadingDownload: false,

        rules: {
            required: v => !!v || "Este campo es requerido",
            number: value => {
                const pattern = /^[\d]*\.?[\d]*$/;
                if (value != undefined && value.toString().trim().length != 0)
                    return pattern.test(value) || "Campo numérico";
                else
                    return true;
            },
            entero: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Número entero";
            }
        },
        encabezadoLayout: {
            //Factura
            tax_id: "tax_id",
            fecha: "fecha",
            numero: "numero",
            numero_exportador: "numero_exportador",
            incoterm: "incoterm",
            //Mercancias
            numero_partida: 'numero_partida',
            numero_bultos: 'numero_bultos',
            unidad_bultos: 'unidad_bultos',
            descripcion: 'descripcion',
            clave_um: 'clave_um',
            moneda: 'moneda',
            cantidad: 'cantidad',
            valor_unitario: 'valor_unitario',
            valor_total: 'valor_total',
            valor_dolares: 'valor_dolares',
            marca: 'marca',
            modelo: 'modelo',
            submodelo: 'submodelo',
            numero_serie: 'numero_serie',
            cbm: 'cbm',
            peso_neto: 'peso_neto',
            peso_bruto: 'peso_bruto',
            fraccion_arancelaria: 'fraccion_arancelaria',
        },
        camposLayout: [{
            //factura
            tax_id: "[RFC o Tax ID del emisor]",
            fecha: "[Fecha de Expedición en formato AAAA-MM-DD]",
            numero: "[Número de Factura]",
            numero_exportador: "[Número de Exportador Autorizado]",
            incoterm: "[Clave Incoterm]",
            //Mercancias
            numero_partida: '[Número de Partida]',
            numero_bultos: '[Número Entero de Empaques/Bultos]',
            unidad_bultos: '[Unidad Medida de Empaques/Bultos, ej. CAJA]',
            descripcion: '[Descripción Genérica]',
            clave_um: '[Clave de la Unidad de Medida]',
            moneda: '[Tipo de Moneda]',
            cantidad: '[Cantidad - hasta 3 decimales]',
            valor_unitario: '[Valor Unitario - hasta 6 decimales]',
            valor_total: '[Valor Total - hasta 6 decimales]',
            valor_dolares: '[Valor Dólares - hasta 4 decimales]',
            marca: '',
            modelo: '',
            submodelo: '',
            numero_serie: '',
            cbm: '[Metros Cúbicos]',
            peso_neto: '',
            peso_bruto: '',
            fraccion_arancelaria: '',

        }],
        camposObligatorios: [
            //factura
            "tax_id",
            "fecha",
            "numero",
            //Mercancias
            "numero_partida",
            "descripcion",
            "clave_um",
            "moneda",
            "cantidad",
            "valor_unitario",
            "valor_total",
            "valor_dolares",
            "cbm",
            "peso_neto",
            "peso_bruto",            
        ],
        ultimoDetalle: '',
    }),

    methods: {
        nextTab() {
            this.$emit('nextTab', 6);
        },
        addNew: function () {
            this.detalles.push(Vue.util.extend({}, {
                //Se debe incluir para poder meter las mercancias, los demas campos no importan, este si porque es un arreglo dentro de otro
                mercancias: [],
            }));
        },
        addDetail: function (index) {
            var detalle = this.detalles[index]
            if (detalle['mercancias'] == undefined)
                detalle['mercancias'] = [];
            detalle['mercancias'].push(Vue.util.extend({}, {}));

            //Scroll al elemento agregado
            var contMercancias = detalle['mercancias'].length - 2; //le restamos 2 para asegurar que el elemento DOM exista
            if (contMercancias >= 1) {
                this.ultimoDetalle = "#newMercancia" + index + "_" + contMercancias;
                const elem = this.$refs.scrollBtn;
                elem.click(new Event("click"));
            }
        },
        remove: function (index) {
            var detalle = this.detalles[index];
            if (this.verificaArchivo(detalle.archivo)) {
                this.$swal({
                    type: "info",
                    title: "Cuidado!",
                    text: 'La factura tiene un archivo adjunto, si desea eliminar la factura primero debe eliminar el archivo.'
                });
            } else
                Vue.delete(this.detalles, index);
        },
        removeDetail: function (index, indexMercancia) {
            var detalle = this.detalles[index]
            Vue.delete(detalle['mercancias'], indexMercancia);
        },
        validaCantidadEnteraOpcional: function(v){            
            if (v===0) {
                return true;
            } 
            if (!!v) { 
                const pattern = /^[\d]*$/;
                return pattern.test(v) || "Campo numérico entero";                                    
            }
            return true;
        },
        setEmisor: function (emisor, indice) {
            var emisores = this.emisores.filter(function (emi) {
                return emi.metadato == emisor;
            });
            this.detalles[indice]['tax_id'] = emisores[0].rfc;
            this.detalles[indice]['pais_vendedor'] = emisores[0].pais.clave_m3 != null ? emisores[0].pais.clave_m3 : emisores[0].pais.nombre;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DDThh:mm
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD[T]HH:mm:SS");
        },
        parseDatePicker(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },

        guardar: function (resolve) {
            var referencia = this.$local_storage.get('referencia');
            var rfc = this.$local_storage.get('rfc');
            if (referencia != null && referencia.trim() != '') {
                const datos = {
                    rfc: rfc,
                    referencia: referencia,
                    facturas: this.detalles,
                };
                if (!this.$refs.form.validate()) {
                    this.$swal({
                        type: "info",
                        title: "Cuidado!",
                        text: 'Datos incompletos en el formulario. Favor de verificar.'
                    });
                    resolve(false);
                } else if (this.formUpdated == true) {
                    this.$root.$dialogLoader.show('Espere un momento por favor..');
                    axios({
                            method: "put",
                            url: this.URL + "actualizar/",
                            data: datos
                        })
                        .then((res) => {
                            this.$root.$dialogLoader.hide();
                            this.modal = false;
                            this.formUpdated = false;
                            this.cargar();

                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa!!",
                                text: "El Detalle de Facturas se guardó correctamente. ¿Desea adjuntar documento digitalizado a las facturas antes de continuar?",
                                footer: "",
                                showCancelButton: true,
                                cancelButtonColor: "#d33",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Si",
                                cancelButtonText: "No"
                            }).then(result => {
                                if (result.value) {
                                    resolve(false);
                                } else {
                                    resolve(true);
                                }
                            });

                        })
                        .catch((error) => {
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: 'Error al guardar los datos!'
                                //showConfirmButton: false,
                            });
                            console.log(error);
                            this.$root.$dialogLoader.hide();
                            this.modal = false;
                            resolve(false);
                        });
                } else {
                    resolve(true);
                }
            } else {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: 'Primero debe guardar datos generales del tráfico'
                });
                resolve(false);
            }
        },

        cargar: function () {
            var referencia = this.$local_storage.get('referencia');
            var rfc = this.$local_storage.get('rfc');
            if (referencia != null && referencia.trim() != '') {
                var datos = {
                    rfc: rfc,
                    referencia: referencia,
                };
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                axios.post(this.URL + 'obtener/', datos)
                    .then((res) => {

                        if (typeof res.data !== 'undefined') {
                            this.detalles = res.data.facturas;
                            var thisC = this;
                            var tax_id = "";
                            var emisoresL = [];
                            this.detalles.forEach(function (el) {
                                el.archivo = thisC.verificaArchivo(el.archivo) ? el.archivo : '';
                                if (el.emisor.toString().trim() == "" || el.pais_vendedor.toString().trim() == "") {
                                    tax_id = thisC.verificaEmisor(el.tax_id, 'obtener')
                                    emisoresL = thisC.emisores.filter(function (emi) {
                                        return emi.rfc.toString().trim().toLowerCase() == tax_id.toString().trim().toLowerCase();
                                    });
                                    if (emisoresL.length > 0) {
                                        if (emisoresL[0].pais != null) {
                                            el.emisor = emisoresL[0].metadato;
                                            el.pais_vendedor = emisoresL[0].pais.clave_m3 != null ? emisoresL[0].pais.clave_m3 : emisoresL[0].pais.nombre;
                                        }
                                    }

                                }

                            })
                        }
                    })
                    .catch((err) => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener las facturas"
                            //showConfirmButton: false,
                        });
                        console.log(err);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.formUpdated = false;
                    });
            }

        },

        cargarEmisores: function () {
            var cliente_id = this.$local_storage.get("id_cliente");
            if (cliente_id > 0) {
                var datos = {
                    cliente: cliente_id,
                };
                axios.post(this.$hostname + 'catalogos/emisores_destinatarios/get_emisores/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            this.emisores = res.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err.response);
                    });
            }

        },
        verificaEmisor: function (emisorrfc, opcion) {
            var search = this.emisores.filter(function (e) {
                return e.rfc.trim().toLowerCase() == emisorrfc.toString().trim().toLowerCase();
            });
            if (search.length > 0) {
                if (opcion == 'verifica')
                    return true;
                else
                    return search[0].rfc;
            } else
                return false;
        },
        verificaFactura: function (factura, emisorrfc) {
            if (this.detalles.length > 0) {
                var search = this.detalles.filter(function (e) {
                    if (e.numero != undefined && e.tax_id != undefined)
                        return e.numero.toString().trim().toLowerCase() == factura.toString().trim().toLowerCase() &&
                            e.tax_id.trim().toLowerCase() == emisorrfc.toString().trim().toLowerCase();
                });
                if (search.length > 0)
                    return true;
                else
                    return false;
            }
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        containsKey(obj, key) {
            return Object.keys(obj).includes(key);
        },
        getObjFactura: function (results) {
            var objFactura = {
                emisor: '',
                tax_id: '',
                pais_vendedor: '',
                fecha: '',
                numero: '',
                numero_exportador: '',
                importe: 0,
                incoterm: '',
                mercancias: [],
            };
            for (var k in objFactura) {
                if (this.containsKey(results, k))
                    objFactura[k] = results[k];
            }
            objFactura.mercancias.push(this.getObjMercancia(results));

            return objFactura;
        },
        getObjMercancia: function (results) {
            var objMercancia = {
                numero_partida: '',
                numero_bultos: '',
                unidad_bultos: '',
                descripcion: '',
                clave_um: '',
                moneda: '',
                cantidad: '',
                valor_unitario: '',
                valor_total: '',
                valor_dolares: '',
                marca: '',
                modelo: '',
                submodelo: '',
                numero_serie: '',
                cbm: '',
                peso_neto: '',
                peso_bruto: '',
                fraccion_arancelaria: '',                
            };
            for (var k in objMercancia) {
                if (this.containsKey(results, k))
                    objMercancia[k] = results[k];
            }
            return objMercancia;
        },
        verificaArchivo: function (archivo) {
            if (archivo == undefined)
                return false;
            else
                return archivo.toString().trim().length > 4;
        },

        beforeUpload(file) {
            const filesize = file.size;

            if (filesize < 1000 * 1000 * 5) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 5MB.",
                footer: ""
            });
            return false;
        },
        handleSuccess({
            results,
            header
        }) {
            /** PLANTILLA */
            this.cargarEmisores();
            var erroresCont = 0;
            var erroresText = '';
            var errorTmp = '';
            var detalle = false;
            var registrosExcel = [];
            for (var k in results) {
                detalle = false;
                var fechaOrig = results[k]["fecha"];
                results[k]["fecha"] = this.parseDateExcel(results[k]["fecha"]);
                var obligatorios = this.verificaObligatorios(results[k]);
                if (obligatorios !== true) {
                    erroresCont++;
                    if (erroresText.indexOf(obligatorios) == -1)
                        erroresText += obligatorios;
                } else if (results[k]["fecha"] == false) {
                    erroresCont++;
                    errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                    if (erroresText.indexOf(errorTmp) == -1)
                        erroresText += errorTmp;
                } else if (!this.verificaEmisor(results[k]["tax_id"], 'verifica')) {
                    erroresCont++;
                    errorTmp = '<br/>' + "- El Tax ID:'" + results[k]["tax_id"] + "' no existe en el catálogo de emisores/destinatarios";
                    if (erroresText.indexOf(errorTmp) == -1)
                        erroresText += errorTmp;
                } else {
                    results[k]["tax_id"] = this.verificaEmisor(results[k]["tax_id"], 'obtener')
                    results[k]["fecha"] = this.parseDate(results[k]["fecha"]);
                    var emisores = this.emisores.filter(function (emi) {
                        return emi.rfc == results[k]["tax_id"];
                    });
                    results[k]["emisor"] = emisores[0].metadato;
                    results[k]["pais_vendedor"] = emisores[0].pais.clave_m3 != null ? emisores[0].pais.clave_m3 : emisores[0].pais.nombre;

                    for (var key in this.detalles) { //Si ya existe la factura solo se agrega la Mercancia
                        if (this.detalles[key].tax_id.toString().trim().toLowerCase() == results[k]["tax_id"].toString().trim().toLowerCase() &&
                            this.detalles[key].numero.toString().trim().toLowerCase() == results[k]["numero"].toString().trim().toLowerCase()) {
                            detalle = true;
                            this.detalles[key]['mercancias'].push(this.getObjMercancia(results[k]));
                        }

                    }
                    if (detalle == false) { //Si es cabecera, se agrega factura y mercancia
                        this.detalles.push(this.getObjFactura(results[k]));
                    }

                    registrosExcel.push(results[k]);
                }
            }

            if (erroresCont > 0) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                    footer: erroresText,
                });
            } else if (registrosExcel.length == 0) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "El archivo no contenía registros válidos para cargar. Favor de verificar.",
                });
            } else {
                this.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "El archivo se cargó correctamente.",
                    footer: '',
                });
            }
            this.modalUpload = false;

        },
        submitFile() {
            /** ZIP o XML de Facturas */
            if (this.file != "") {
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                this.cargarEmisores();
                //let formData = new FormData();
                var registrosExcel = [];
                /*formData.append('file', this.file);    
                formData.append('tipo', 'mercancia');
                formData.append('referencia', this.$local_storage.get("referencia"));
                formData.append('user_updated', this.$local_storage.get("email"));
                formData.append('usuario', this.$local_storage.get("id_usuario"));*/
                let formData = {
                    file: this.file,
                    filename: this.fileName,
                    tipo: 'mercancia',
                    referencia: this.$local_storage.get("referencia"),
                    user_updated: this.$local_storage.get("email"),
                    usuario: this.$local_storage.get("id_usuario"),
                };

                axios.post(this.$hostname + 'leexml/', formData)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            //console.log(res.data);

                            /*var results = res.data;  
                var erroresCont = 0;
                var erroresText = '';
                var errorTmp = '';
                results.forEach(element => {                  
                  if (!this.verificaEmisor(element.tax_id, 'verifica'))  {
                      erroresCont++;                      
                      errorTmp = '<br/>'+ "- El emisor '"+ element.emisor +"' no existe en el catálogo de emisores/destinatarios con el Tax ID: '"+element.tax_id+"'";
                      if (erroresText.indexOf(errorTmp) == -1) 
                        erroresText += errorTmp;
                  } else if (this.verificaFactura(element.numero, element.tax_id)){
                      erroresCont++;                      
                      errorTmp = '<br/>'+ "- La factura número '"+ element.numero +"' del emisor '"+element.tax_id+"' ya ha sido registrada";
                      if (erroresText.indexOf(errorTmp) == -1) 
                        erroresText += errorTmp;
                  } else{
                      element.tax_id = this.verificaEmisor(element.tax_id, 'obtener')
                      element.fecha = this.parseDate(element.fecha);
                      var emisores = this.emisores.filter(function(emi){
                          return emi.rfc == element.tax_id;
                      });
                      element.emisor = emisores[0].metadato;
                      element.pais_vendedor = emisores[0].pais.clave_m3 != null? emisores[0].pais.clave_m3 : emisores[0].pais.nombre;
                      
                      this.detalles.push(element); 
                      registrosExcel.push(element);                        
                  }
              });  
                            
              if (erroresCont > 0) {
                  this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: erroresText,
                    });                                                                              
              } else if (registrosExcel.length == 0) {            
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "El archivo no contenía registros válidos para cargar. Favor de verificar.",                
                    });                
              } else {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El archivo se cargó correctamente.",
                        footer: '',
                    });  
              }*/
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                footer: '',
                            });
                            this.modal = false;
                            this.cargar();

                        }

                    })
                    .catch((error) => {
                        var msg = ''
                        var mostrar = true;
                        if (error.response != null) {
                            if (error.response.data.mensaje != null)
                                msg = error.response.data.mensaje[0];
                            if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine                
                                mostrar = false;
                                this.$swal({
                                    type: "success",
                                    title: "¡Operación Exitosa!",
                                    text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                    footer: '',
                                });
                                msg = error.response.data.message;
                                this.cargar();
                            }
                        }
                        if (mostrar) {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al cargar el archivo",
                                footer: msg,
                            });
                            console.log(error);
                        }

                    }).then(() => {
                        this.modal = false;
                        this.$root.$dialogLoader.hide();
                        this.reset();
                    });
            }

        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
            if (this.file.size > 1000 * 1000 * 3) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "El archivo no debe ser mayor a 3MB.",
                });
                this.file = "";
                this.fileName = "";
                this.$refs.file.value = "";
                this.showfile = false;
            } else {
                const fr = new FileReader();
                fr.readAsDataURL(this.$refs.file.files[0]);
                fr.addEventListener('load', () => {
                    this.file = fr.result; // archivo en base64
                });
                this.fileName = this.file.name;
                this.showfile = true;
            }
        },

        addFileFactura: function (numero_factura, rfc, archivo) {
            this.modalFactura = true;
            this.modalFacturaNumero = numero_factura;
            this.modalFacturaArchivo = archivo;
            this.modalFacturaRfc = rfc;
        },

        handleFileUploadFactura() {
            this.fileFactura = this.$refs.fileFactura.files[0];
            this.sizeFactura = this.fileFactura.size;
            var nombre = this.fileFactura.name.split(".");
            if (this.modalFacturaNumero != nombre[0]) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "El nombre del archivo no coincide con el número de factura. Favor de verificar.",
                });
                this.fileFactura = "";
                this.fileFacturaName = "";
                this.reset();
            } else if (this.fileFactura.size > 1000 * 1000 * 3) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "El archivo no debe ser mayor a 3MB.",
                });
                this.fileFactura = "";
                this.fileFacturaName = "";
                this.reset();
            } else {
                const fr = new FileReader();
                fr.readAsDataURL(this.$refs.fileFactura.files[0]);
                fr.addEventListener('load', () => {
                    this.fileFactura = fr.result; // archivo en base64
                });
                this.fileFacturaName = this.fileFactura.name;
                this.showfile = true;
            }
        },

        submitFileFactura: async function (rfc_emisor) {
            /** Documento de Factura */
            if (this.fileFacturaName != "") {

                var nombreArchivo = "170_"+ this.fileFacturaName.replace(/.pdf/ig,".pdf");
                var referencia = this.$local_storage.get('referencia').split("-");
                // 170 es porque por default se considera factura
                var keyBucket = this.$local_storage.get("rfc") + "/traficos/" +
                    referencia[1] + "/adjuntos/170/" + nombreArchivo;
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                /*let formData = new FormData();          
                formData.append('file', this.fileFactura);                 
                formData.append('key', keyBucket); */

                let formData = {
                    file: this.fileFactura,
                    key: keyBucket,
                    usuario: this.$local_storage.get("id_usuario"),
                };

                axios.post(this.$hostname + 'uploads3/', formData)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            var thisC = this;
                            this.detalles.forEach(function (el) {
                                if (el.tax_id == rfc_emisor && el.numero == thisC.modalFacturaNumero) {
                                    thisC.formUpdated = true;
                                    el.archivo = keyBucket;
                                }

                            });

                            this.actualizarAdjuntosTrafico(nombreArchivo);
                            this.modalFactura = false;
                            //Despues de subir el archivo a S3, guardamos el detalle para asegurar que se guarde el campo archivo
                            return new Promise((resolve, reject) => {
                                this.guardar(resolve);
                            });

                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el documento de factura",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.modalFactura = false;
                        this.$root.$dialogLoader.hide();
                        this.reset();
                    });
            }

        },

        actualizarAdjuntosTrafico: function(fileArchivo){               
            var adjuntos = [{"filename":fileArchivo.replace(/.pdf/ig,""),
                        "ext":"pdf",
                        "size":this.sizeFactura,
                        "email_usuario": this.$local_storage.get("email"),
                        "nombre_usuario":this.$local_storage.get("nombre_usuario"),
                        "iniciales":"",
                        "perfil_usuario":"",
                        "tipo_usuario": this.$local_storage.get("tipo_usuario"),
                        "fuente":"sistema"}];
            var datos = {
                "referencia": this.$local_storage.get('referencia'),
                "adjuntos": adjuntos
            }
            axios.post(this.$hostname + 'traficos/set_adjuntos/', datos)
                .then((res) => {
                    
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al guardar el registro adjunto en el tráfico. Favor de comunicarse con soporte.",
                        footer: '',
                    });
                    console.log(error);
                });
        },

        downloadFileFactura: async function (archivo_key) {
            this.loadingDownload = true;
            var datos = {
                id: archivo_key
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        //a.download = name[name.length - 1];
                        a.click();
                        a.parentNode.removeChild(a);

                        this.modalFactura = false;
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar en S3",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el documento de factura";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.loadingDownload = false;
                    this.reset();
                });
        },

        deleteFileFactura: async function (archivo_key) {
            this.loadingDelete = true;
            var datos = {
                key: archivo_key
            }
            axios.post(this.$hostname + 's3/delete/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var thisC = this;
                        this.detalles.forEach(function (el) {
                            if (el.tax_id == thisC.modalFacturaRfc && el.numero == thisC.modalFacturaNumero) {
                                thisC.formUpdated = true;
                                el.archivo = '';
                            }

                        });
                        this.modalFactura = false;
                        this.deleteAdjunto(archivo_key);
                        //Despues de eliminar el archivo de S3, guardamos el detalle para asegurar que se guarde el campo archivo
                        return new Promise((resolve, reject) => {
                            this.guardar(resolve);
                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar en S3",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al intentar eliminar el documento",
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.loadingDelete = false;
                    this.reset();
                });
        },

        deleteAdjunto: function(archivokey){
            var datos = {
                key: archivokey
            }
            axios.post(this.$hostname + 'traficos/delete_adjunto/', datos)
                .then((res) => {
                    
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al eliminar el registro adjunto del tráfico. Favor de comunicarse con soporte.",
                        footer: '',
                    });
                    console.log(error);
                });
        },

        formChanged: function (newV, oldV) {
            this.formUpdated = true;
            var sumtotal = 0;
            for (var k in this.detalles) {
                var sum = 0;
                var tieneMercancia = false;
                var detalle = this.detalles[k];
                if (detalle != undefined) {
                    detalle['mercancias'].forEach(function (e) {
                        tieneMercancia = true;
                        if (e.valor_dolares != undefined && e.valor_dolares > 0)
                            sum += parseFloat(e.valor_dolares);
                    });
                    if (tieneMercancia)
                        this.detalles[k].importe = sum;
                    else
                        sum = (this.detalles[k].importe != undefined && this.detalles[k].importe.toString().trim() != '') ? parseFloat(this.detalles[k].importe) : 0;
                }
                sumtotal += sum;
            }
            this.total_usd = sumtotal;
        },
        reset() {
            const input = this.$refs.file;
            input.type = 'text'
            input.type = 'file'

            const inputFactura = this.$refs.fileFactura;
            inputFactura.type = 'text'
            inputFactura.type = 'file'

            this.showfile = false;
        },

    }, //methods

    filters: {
        moneda: function (value) {
            if (value) {
                var parts = value.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            }
        }
    },

    created: function () {
        this.URL = this.$hostname + 'traficos/';
        this.$root.$dialogLoader.show('Espere un momento por favor..');
        this.cargarEmisores();
        this.cargar();
        this.formUpdated = false;
        this.$watch('detalles', this.formChanged, {
            deep: true
        });
    },
    beforeDestroy: function () {
        this.detalles = [];
    },
}
</script>

<style scoped>
#trafico-detalle-facturas {
    font-size: small ;
    /* | x-small | small  */
}

#trafico-detalle-facturas>>>.v-input {
    /*Texto dentro del input*/
    font-size: x-small !important;
}

#trafico-detalle-facturas>>>.v-label {
    /*Etiqueta o placeholder del input*/
    font-size: x-small !important;
    margin-top: 5px !important;
}

#trafico-detalle-facturas>>>.v-messages__message {
    /*Mensaje de Error*/
    font-size: x-small !important;
    margin-top: -0px !important;
}

#trafico-detalle-facturas>>>.form-group {
    /*Celda de cada v-input */
    margin-top: 0px !important;
    margin-bottom: -5px !important;
    margin-right: -10px !important;
    margin-left: -10px !important;
}

#detalle_mercancias {
    /*Div delas mercancias de una factura */
    margin-left: 25px !important;
}

#trafico-detalle-facturas>>>#separaFactura {
    /*Separador de cada factura */
    background-color: black !important;
    height: 2px;
}

#trafico-detalle-facturas>>>#separaMercancia {
    /*Separador de cada Mercancia */
    background-color: blue !important;
    margin-bottom: -5px !important;
}
</style>
